import React, { useEffect } from 'react';

function Badges() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://cdn.credly.com/assets/utilities/embed.js';
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <section id="digital-badges" aria-labelledby="badges-label">
      <div className="badges-content revealable">
        <h2 id="badges-label">Verified Digital Badges</h2>
        <div className="badge-gallery">
          <div className="badge-item" data-iframe-width="150" data-iframe-height="270" data-share-badge-id="b5fd2698-32a3-4280-b6a8-89a303bd379f" data-share-badge-host="https://www.credly.com"></div>
          <div className="badge-item" data-iframe-width="150" data-iframe-height="270" data-share-badge-id="637a417e-6638-4f8f-ad41-44def36fe49c" data-share-badge-host="https://www.credly.com"></div>
          <div className="badge-item" data-iframe-width="150" data-iframe-height="270" data-share-badge-id="7b87ebea-8578-4f5b-998c-2aa4fd2b7b0b" data-share-badge-host="https://www.credly.com"></div>
          <div className="badge-item" data-iframe-width="150" data-iframe-height="270" data-share-badge-id="ff5fc274-45ea-4106-a2d8-8918dd00bdd3" data-share-badge-host="https://www.credly.com"></div>
          <div className="badge-item" data-iframe-width="150" data-iframe-height="270" data-share-badge-id="c15fd763-f171-4fcc-b6e9-6f7825839e85" data-share-badge-host="https://www.credly.com"></div>
          <div className="badge-item" data-iframe-width="150" data-iframe-height="270" data-share-badge-id="61ffc248-f557-47bc-8f15-4cc7af2ce095" data-share-badge-host="https://www.credly.com"></div>
        </div>
      </div>
    </section>
  );
}

export default Badges;